import type { ParsedUrlQuery } from 'querystring';
import type { AllTrailsCenter } from '@alltrails/maps/types/Geo';
import getSearchParamsMapPosition, { defaultZoom } from './getSearchParamsMapPosition';

// HQ!
const fallbackCenter: AllTrailsCenter = [37.789802, -122.4127311, defaultZoom];

const getInitialMapPosition = (searchParams: ParsedUrlQuery, userLocation?: { lat: number; lng: number }) => {
  const { bounds, center } = getSearchParamsMapPosition(searchParams);

  if (bounds || center) {
    return { bounds, center };
  }

  if (userLocation?.lat !== undefined && userLocation?.lng !== undefined) {
    const cloudFrontCenter: AllTrailsCenter = [userLocation.lat, userLocation.lng, defaultZoom];
    return { center: cloudFrontCenter, bounds: undefined };
  }

  return { bounds: undefined, center: fallbackCenter };
};

export default getInitialMapPosition;
